import {ReviewEntry} from "src/app/model/ReviewEntry";
import FileSaver from "file-saver";
import {v4 as uuid} from "uuid";
import {generateReviewUrl} from "src/app/util/ReviewUrlUtil";

export namespace CsvUtil {
    export function generateCsv(rows: ReviewEntry[] | undefined, header: string) {
        if (rows == undefined || rows.length == 0) {
            return;
        }
        let content = header;
        content += '\n';
        content += rows.map(row => generateCsvRow(row)).join("\n");

        const exportContent = '\uFEFF';
        const blob = new Blob([exportContent + content], {
            type: "text/plain;charset=utf-8"
        });
        const randomName = uuid();
        const fileName = randomName + ".csv"
        FileSaver.saveAs(blob, fileName);
    }

    const generateCsvRow = (row: ReviewEntry) => {
        const array = [];
        array.push(row.referenceSubType);
        array.push(row.country);
        array.push(row.referenceId);
        array.push(row.providerId);
        array.push(row.reviewId);
        array.push(row.caseType);
        array.push(row.caseSubType);
        array.push(row.creationDate);
        array.push(row.primaryCaseCompletionDate || "");
        array.push(row.secondaryCaseCompletionDate || "");
        array.push(row.reviewStatus);
        array.push(row.reviewResult);
        array.push(generateReviewUrl(row.reviewId));
        return array.join(",");
    }
}